import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../api/axios";
import loadStatus from "../util/loadStatus";

export const getCountries = createAsyncThunk(
  "countries/getCountries",
  async (reqData, { rejectWithValue, getState }) => {
    try {
      const state = getState().countries;
      if (state.count.getCountries <= 1) {
        const res = await axios.get("/countries", { params: reqData });
        return res.data;
      }
      return state.data;
    } catch (error) {
      if (error.response && error.response.data) {
        return rejectWithValue(error.response.data);
      }
      return rejectWithValue(error);
    }
  }
);

export const addCountry = createAsyncThunk(
  "countries/addCountry",
  async (reqData, { rejectWithValue }) => {
    try {
      const res = await axios.post("/add-country", reqData);
      return res.data;
    } catch (error) {
      if (error.response && error.response.data) {
        return rejectWithValue(error.response.data);
      }
      return rejectWithValue(error);
    }
  }
);

export const editCountry = createAsyncThunk(
  "countries/editCountry",
  async ({ id, reqData }, { rejectWithValue }) => {
    try {
      const res = await axios.put("/edit-country" + id, reqData);
      return res.data;
    } catch (error) {
      if (error.response && error.response.data) {
        return rejectWithValue(error.response.data);
      }
      return rejectWithValue(error);
    }
  }
);

export const deleteCountry = createAsyncThunk(
  "countries/deleteCountry",
  async (reqData, { rejectWithValue }) => {
    try {
      const res = await axios.delete("/delete-country", reqData);
      return res.data;
    } catch (error) {
      if (error.response && error.response.data) {
        return rejectWithValue(error.response.data);
      }
      return rejectWithValue(error);
    }
  }
);

const countriesSlice = createSlice({
  name: "countries",
  initialState: {
    total: 0,
    data: [],
    selected: {},
    loading: false,
    error: null,
    load: {
      getCountries: false,
      getCountry: false,
      addCountry: false,
      editCountry: false,
      deleteCountry: false,
    },
    count: { getCountries: 0, getCountry: 0 },
  },
  reducers: {
    setCountries: (state, action) => {
      state.data = action.payload;
    },
    setSelectedCountry: (state, action) => {
      state.selected = action.payload;
    },
    unsetCountries: (state) => {
      state.data = [];
      state.selected = {};
    },
  },
  extraReducers: (builder) => {
    builder
      //Get all Countries
      .addCase(getCountries.pending, (state) => {
        state.load.getCountries = loadStatus.loading;
        state.error = null;
        state.count.getCountries = ++state.count.getCountries;
      })
      .addCase(getCountries.fulfilled, (state, action) => {
        state.load.getCountries = loadStatus.success;
        state.data = action.payload;
        state.count.getCountries = 0;
      })
      .addCase(getCountries.rejected, (state, action) => {
        state.load.getCountries = loadStatus.error;
        state.error = action.payload;
        state.count.getCountries = 0;
      })
      //Add Country
      .addCase(addCountry.pending, (state) => {
        state.load.addCountry = loadStatus.loading;
        state.error = null;
      })
      .addCase(addCountry.fulfilled, (state, action) => {
        state.load.addCountry = loadStatus.success;
        state.data.unshift(action.payload);
      })
      .addCase(addCountry.rejected, (state, action) => {
        state.load.addCountry = loadStatus.error;
        state.error = action.payload;
      })
      //Update Country
      .addCase(editCountry.pending, (state) => {
        state.load.editCountry = loadStatus.loading;
        state.error = null;
      })
      .addCase(editCountry.fulfilled, (state, action) => {
        state.load.editCountry = loadStatus.success;
        const index = state.data.findIndex(
          (country) => (country.id = action.payload.id)
        );
        if (index !== -1) {
          state.data[index] = action.payload;
        }
      })
      .addCase(editCountry.rejected, (state, action) => {
        state.load.editCountry = loadStatus.error;
        state.error = action.payload;
      })
      //Delete Country
      .addCase(deleteCountry.pending, (state) => {
        state.load.deleteCountry = loadStatus.loading;
        state.error = null;
      })
      .addCase(deleteCountry.fulfilled, (state, action) => {
        state.load.deleteCountry = loadStatus.success;
        state.data.filter((country) => country.id !== action.meta.arg.id);
      })
      .addCase(deleteCountry.rejected, (state, action) => {
        state.load.deleteCountry = loadStatus.error;
        state.error = action.payload;
      });
  },
});

export const { setCountries, setSelectedCountry, unsetCountries } =
  countriesSlice.actions;
export default countriesSlice.reducer;
